import { useFailClosedFlag } from './useFailClosedFlag';
import { flagsmithFeatureFlags } from '@/lib/flagsmith';

/**
 * Resolves the `agentmesh_mcp_risk` flag for the Inventory MCP Servers
 * Risk column and card (KIR-5108) — its own flag, separate from the
 * Extensions risk estimate (`agentmesh_risk_estimate`). Fails closed on
 * loading/error so the column never flashes in before the flag is known.
 */
export function useAgentmeshMcpRiskEnabled(): {
  enabled: boolean;
  isLoading: boolean;
} {
  return useFailClosedFlag(flagsmithFeatureFlags.AGENTMESH_MCP_RISK);
}
